
const SCRIPT_URL = "https://app.octaneai.com/xt0dhni0h69qoq5u/quiz.js";

export default {
  name: "PdpPillowHeightGuide",

  props: {
    tags: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      showModal: false,
    };
  },

  computed: {
    isPillow() {
      return this.tags?.includes("pillows");
    },
  },

  mounted() {
    if (this.isPillow) {
      this.preloadScript();
    }
  },

  beforeDestroy() {
    const script = document.querySelector(`script[src="${SCRIPT_URL}"]`);
    if (script) {
      script.remove();
    }
    if (window.OctaneAI) {
      delete window.OctaneAI;
    }
    if (window.OctaneConfig) {
      delete window.OctaneConfig;
    }
  },

  methods: {
    preloadScript() {
      if (typeof window !== "undefined") {
        if ("requestIdleCallback" in window) {
          window.requestIdleCallback(
            () => {
              this.loadOctaneScript(true);
            },
            { timeout: 3000 }
          );
        } else {
          setTimeout(() => {
            this.loadOctaneScript(true);
          }, 2000);
        }
      }
    },

    openQuiz() {
      this.showModal = true;
      this.loadOctaneScript(false);
    },

    closeQuiz() {
      this.showModal = false;
    },

    loadOctaneScript(isPreload = false) {
      // If Octane is already loaded globally
      if (window.OctaneAI) {
        if (!isPreload && typeof window.OctaneAI.init === "function") {
          window.OctaneAI.init();
        }
        return;
      }

      // Check if script is already present in document
      let script = document.querySelector(`script[src="${SCRIPT_URL}"]`);
      if (!script) {
        script = document.createElement("script");
        script.src = SCRIPT_URL;
        script.defer = true;

        script.onload = () => {
          if (
            !isPreload &&
            window.OctaneAI &&
            typeof window.OctaneAI.init === "function"
          ) {
            window.OctaneAI.init();
          }
        };

        document.body.appendChild(script);
      } else {
        // If the script tag exists but window object is not yet populated
        const originalOnload = script.onload;
        script.onload = event => {
          if (originalOnload) originalOnload(event);
          if (
            !isPreload &&
            window.OctaneAI &&
            typeof window.OctaneAI.init === "function"
          ) {
            window.OctaneAI.init();
          }
        };
      }
    },
  },
};
